module.exports = __webpack_public_path__ + "static/media/tm.e2d027ac.svg";